import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

export function getProjectWorkspace(projectId) {
  return request({
    url: `/api/project-finance/project/${projectId}/workspace`,
    method: 'get'
  })
}

export function createProjectExpense(projectId, data) {
  return request({
    url: `/api/project-finance/project/${projectId}/expense`,
    method: 'post',
    data
  })
}

export function updateProjectExpense(projectId, expenseId, data) {
  return request({
    url: `/api/project-finance/project/${projectId}/expense/${expenseId}`,
    method: 'put',
    data
  })
}

export function deleteProjectExpense(projectId, expenseId) {
  return request({
    url: `/api/project-finance/project/${projectId}/expense/${expenseId}`,
    method: 'delete'
  })
}

export function createPaymentRecord(projectId, data) {
  return request({
    url: `/api/project-finance/project/${projectId}/payment`,
    method: 'post',
    data
  })
}

export function updatePaymentRecord(projectId, paymentId, data) {
  return request({
    url: `/api/project-finance/project/${projectId}/payment/${paymentId}`,
    method: 'put',
    data
  })
}

export function deletePaymentRecord(projectId, paymentId) {
  return request({
    url: `/api/project-finance/project/${projectId}/payment/${paymentId}`,
    method: 'delete'
  })
}

/** 仅关联发票，不修改收款其它字段 */
export function linkPaymentInvoice(projectId, paymentId, invoiceId) {
  return request({
    url: `/api/project-finance/project/${projectId}/payment/${paymentId}/invoice`,
    method: 'put',
    data: { invoiceId }
  })
}

export function uploadProjectAttachment(projectId, payload) {
  const fd = new FormData()
  fd.append('file', payload.file)
  if (payload.attachmentTypeCode != null) fd.append('attachmentTypeCode', payload.attachmentTypeCode)
  if (payload.contractId != null) fd.append('contractId', payload.contractId)
  if (payload.invoiceId != null) fd.append('invoiceId', payload.invoiceId)
  if (payload.changeOrderId != null) fd.append('changeOrderId', payload.changeOrderId)
  if (payload.expenseId != null) fd.append('expenseId', payload.expenseId)
  if (payload.paymentRecordId != null) fd.append('paymentRecordId', payload.paymentRecordId)
  if (payload.quoteId != null) fd.append('quoteId', payload.quoteId)
  if (payload.remarkText) fd.append('remarkText', payload.remarkText)
  return request({
    url: `/api/project-finance/project/${projectId}/attachment/upload`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function downloadAttachmentUrl(attachmentId) {
  return `${resolveApiBase()}/api/project-finance/attachment/${attachmentId}/download`
}

export function previewAttachmentUrl(attachmentId) {
  return `${resolveApiBase()}/api/project-finance/attachment/${attachmentId}/preview`
}
